import {Grid, Box} from "@mui/material"
import {useEffect, type FC} from "react"
import {
  DeliverablesTable,
  ErrorBoundary,
  ThoughtPieceOverview,
  TrainingTile,
  MainContentTile
} from "../../components"
import useHomeNavigation from "../../hooks/useHomeNavigation"
import useHomepageTabStore from "../../stores/homepageTabStore"

const Overview: FC = () => {
  const {setCurrentTab} = useHomepageTabStore()
  const {addNavigationHistory, clearNavigationHistory} = useHomeNavigation()

  useEffect(() => {
    setCurrentTab("Overview")
    clearNavigationHistory()
    addNavigationHistory("Overview")
  }, [])

  return (
    <Box sx={{flexGrow: 1}} id="overview-box" component="main">
      <Grid
        component="section"
        container
        spacing={2}
        style={{
          paddingBottom: "5px",
        }}
      >
        <Grid
          id="deliverables-table"
          component="section"
          size={12}
          style={{
            backgroundColor: "#FBFBFB",
          }}
        >
          <ErrorBoundary redirectPath="/error?message=Unexpected error displayed in My deliverables tile">
            <DeliverablesTable />
          </ErrorBoundary>
        </Grid>
        <Grid id="main-content" size={8} component="section">
          <MainContentTile />
        </Grid>
        <Grid id="thought-piece-overview" size={4} component="section">
          <Box
            sx={{
              width: "100%",
              backgroundColor: "#fff",
              textAlign: "center",
              height: "275px",
              color: "#212121",
              borderRadius: "8px",
            }}
          >
            <ThoughtPieceOverview />
          </Box>
          <Box
            id="training-courses"
            component="section"
            sx={{
              height: "auto",
              marginTop: "20px",
              backgroundColor: "#fff",
            }}
          >
            <TrainingTile />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

Overview.displayName = "Overview"

export default Overview
